import { CheckCircle2, Clock, XCircle, AlertTriangle, Edit3, Loader2, Ban, FlaskConical, Send, HelpCircle } from "lucide-react";

const MAP = {
  draft: ["slate", Edit3], not_submitted: ["slate", Edit3], internal_review: ["amber", Clock], submission_pending: ["amber", Loader2],
  submitted: ["sky", Send], kyc_pending: ["amber", Clock], bank_review: ["amber", Clock], provider_review: ["amber", Clock],
  correction_required: ["purple", AlertTriangle], internal_approved: ["sky", CheckCircle2], approved: ["emerald", CheckCircle2],
  account_created: ["emerald", CheckCircle2], provisioning: ["sky", Loader2], active: ["emerald", CheckCircle2], rejected: ["red", XCircle],
  withdrawn: ["slate", Ban], expired: ["slate", Ban], integration_error: ["red", AlertTriangle], unknown: ["amber", HelpCircle],
  assisted_pending: ["purple", Clock], uploaded: ["slate", Clock], processing: ["sky", Loader2], unreadable: ["red", AlertTriangle],
  extracted: ["amber", Clock], applicant_confirmed: ["sky", CheckCircle2], internally_reviewed: ["emerald", CheckCircle2],
  provider_accepted: ["emerald", CheckCircle2], superseded: ["slate", Ban], exact_match: ["emerald", CheckCircle2], partial_match: ["amber", AlertTriangle],
  mismatch: ["red", XCircle], unavailable: ["slate", HelpCircle], pending: ["amber", Clock], approved_for_settlement: ["emerald", CheckCircle2],
  pending_internal_review: ["amber", Clock], provider_confirmed: ["emerald", CheckCircle2], blocked: ["purple", Ban], dead_letter: ["red", XCircle],
  succeeded: ["emerald", CheckCircle2], queued: ["slate", Clock], retry_scheduled: ["amber", Clock], in_flight: ["sky", Loader2],
};
const COLORS = {
  slate: "bg-slate-100 text-slate-700 border-slate-300", amber: "bg-amber-50 text-amber-800 border-amber-300", sky: "bg-sky-50 text-sky-800 border-sky-300",
  emerald: "bg-emerald-50 text-emerald-800 border-emerald-300", red: "bg-red-50 text-red-800 border-red-300", purple: "bg-purple-50 text-purple-800 border-purple-300",
};

export const StatusBadge = ({ status, testid, prefix }) => {
  const [c, Icon] = MAP[status] || ["slate", HelpCircle];
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-1 text-xs font-semibold capitalize ${COLORS[c]}`}>
      <Icon className="h-3.5 w-3.5" aria-hidden />
      {prefix ? `${prefix}: ` : ""}
      {(status || "unknown").replace(/_/g, " ")}
    </span>
  );
};

export const EnvBadge = ({ env, testid }) =>
  env === "sandbox" ? (
    <span data-testid={testid} className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-dashed border-amber-400 bg-amber-50 px-2.5 py-1 font-mono text-[10px] font-bold uppercase tracking-wider text-amber-800">
      <FlaskConical className="h-3 w-3" /> Sandbox - not real
    </span>
  ) : env === "manual_evidence" ? (
    <span className="rounded-md border border-slate-300 px-2 py-0.5 text-[10px] font-semibold uppercase">Manual + evidence</span>
  ) : null;
